import LegalPage from "./LegalPage";

export default function Cookies() {
  return <LegalPage contentKey="cookies" testId="cookies-page" />;
}
